export default "__VITE_ASSET__CKwwy1LD__"